module.exports = __webpack_public_path__ + "static/media/shejiebei_headkv.d8956684.png";